<template>
  <div>
    {{ $t('installApp.begin') }}
    <div class="mt-3">
      <h4>1. {{ $t('installApp.header')[0] }}</h4>
      {{ $t('installApp.content')[0] }}
      <div>
        <b-button
          class="my-2"
          variant="primary"
          href='https://discord.com/oauth2/authorize?client_id=1289127316936720396'
          target='_blank'
        >
          <b-icon icon="discord" aria-hidden="true"></b-icon>
          {{ $t('installApp.install') }}
        </b-button>
      </div>
    </div>
    <div class="mt-3">
      <h4>2. {{ $t('installApp.header')[1] }}</h4>
      {{ $t('installApp.content')[1] }}
      <div>
        <img class="m-1 w-75" alt="step 2" src="@/assets/install-app-3.jpg">
      </div>
    </div>
    <div class="mt-3">
      <h4>3. {{ $t('installApp.header')[2] }}</h4>
      {{ $t('installApp.content')[2] }}
      <div>
        <b-button
          class="my-2"
          variant="primary"
          href='https://discord.gg/jzazZGwc2J'
          target='_blank'
        >
          <b-icon icon="discord" aria-hidden="true"></b-icon>
          {{ $t('installApp.joinDiscord') }}
        </b-button>
      </div>
    </div>
    <div class="mt-3">
      <h4>4. {{ $t('installApp.header')[3] }}</h4>
      {{ $t('installApp.content')[3] }}
      <div>
        <img class="m-1 w-75" alt="step 4" src="@/assets/install-app-2.jpg">
      </div>
    </div>
    {{ $t('installApp.end') }}
  </div>
</template>

<script>
export default {
  name: 'InstallApp',
}
</script>

